import { forwardRef } from "react";

import type { SVGIconProps } from "../types";

export const OsChromeIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = "currentColor", size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_51_305"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_305)">
        <path
          d="M6.58755 14.346C3.6775 13.7012 1.5 11.1051 1.5 8C1.5 6.8157 1.81655 5.7055 2.37035 4.7487L5.1543 9.57105C5.46714 10.1379 5.94214 10.5983 6.51841 10.8934C7.09467 11.1885 7.74593 11.3047 8.3887 11.2273L6.58755 14.346ZM8 14.5L10.7865 9.67375C11.09 9.16821 11.2502 8.58963 11.25 8C11.2509 7.29665 11.0228 6.61212 10.6 6.05H14.2023C14.4002 6.68107 14.5005 7.33864 14.5 8C14.5 11.59 11.5899 14.5 8 14.5ZM9.6718 9.00425C9.49701 9.29525 9.24929 9.53558 8.95313 9.70148C8.65697 9.86737 8.32263 9.95308 7.98319 9.95012C7.64374 9.94717 7.31095 9.85566 7.01772 9.68463C6.7245 9.51361 6.48099 9.269 6.3113 8.975L6.29245 8.9425C6.12785 8.64423 6.04427 8.30803 6.05002 7.9674C6.05578 7.62677 6.15068 7.29359 6.32527 7.00104C6.49986 6.7085 6.74804 6.4668 7.0451 6.30002C7.34217 6.13323 7.67774 6.04719 8.0184 6.05045C8.35907 6.05371 8.69293 6.14616 8.98675 6.3186C9.28057 6.49104 9.52408 6.73744 9.69304 7.03327C9.862 7.3291 9.9505 7.66404 9.94974 8.00472C9.94898 8.3454 9.85898 8.67993 9.6887 8.975L9.6718 9.00425ZM3.2108 3.60536C3.81893 2.94086 4.55891 2.41043 5.38351 2.04793C6.20812 1.68544 7.09923 1.49882 8 1.50001C9.14118 1.49981 10.2623 1.80005 11.2506 2.37056C12.239 2.94106 13.0597 3.76171 13.6303 4.75H8C7.36333 4.74978 6.74062 4.93657 6.20918 5.28716C5.67775 5.63776 5.26099 6.13672 5.01065 6.7221L3.2108 3.60536Z"
          fill={color}
        />
      </g>
    </svg>
  ),
);

OsChromeIcon.displayName = "OsChromeIcon";
